import {LinearProgress, Container, Box} from '@mui/material';

export default function InitScreen() {
  return (
    <Container component="main" maxWidth="xs" style={styles.container}>
      <Box>
        <img
          alt='logon2'
          width={100}
          height={100}
          src={`assets/img/logon2app.png`}
        />
        <LinearProgress sx={{mt: 1, mb: 1}} color="info" />
      </Box>
    </Container>
  );
}

const styles = {
  container: {
    height: '90vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};